import { render, staticRenderFns } from "./UpdateStatusModal.vue?vue&type=template&id=12ef86ba&scoped=true&"
import script from "./UpdateStatusModal.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStatusModal.vue?vue&type=style&index=0&id=12ef86ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef86ba",
  null
  
)

export default component.exports